var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionHelpCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.792 11.8909C10.7899 10.4702 11.8856 9.28914 13.3025 9.18479C14.7194 9.08044 15.9762 10.0882 16.1823 11.494C16.3884 12.8997 15.4736 14.2258 14.0864 14.5325C13.7491 14.5991 13.5044 14.8928 13.5 15.2366V16.0404",
    stroke: "currentColor",
    strokeWidth: 1.29904
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4999 17.8486C13.5996 17.8486 13.6804 17.9295 13.6804 18.0292C13.6804 18.1289 13.5996 18.2097 13.4999 18.2097C13.4002 18.2097 13.3193 18.1289 13.3193 18.0292C13.3193 17.9295 13.4002 17.8486 13.4999 17.8486",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 17.8486C13.5996 17.8486 13.6804 17.9295 13.6804 18.0292C13.6804 18.1289 13.5996 18.2097 13.4999 18.2097C13.4002 18.2097 13.3193 18.1289 13.3193 18.0292C13.3193 17.9295 13.4002 17.8486 13.4999 17.8486",
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4999 21.8269C18.0865 21.8269 21.8046 18.1088 21.8046 13.5223C21.8046 8.93576 18.0865 5.21765 13.4999 5.21765C8.91342 5.21765 5.19531 8.93576 5.19531 13.5223C5.19531 18.1088 8.91342 21.8269 13.4999 21.8269Z",
    stroke: "currentColor",
    strokeWidth: 1.29904
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionHelpCircle);
export default __webpack_public_path__ + "static/media/question-help-circle.1233bfe07802789a3f258dcb226d6dd8.svg";
export { ForwardRef as ReactComponent };